/**
*
* TopicHeader
*
*/

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import UserText from 'components/media/UserText/Loadable.js';
import { FormControl } from 'react-bootstrap';
import FlagButton from 'components/interaction/FlagButton.jsx';
import SelectRecipients from 'components/interaction/SelectRecipients/index.jsx';
import ControlMenu from 'components/interaction/ControlMenu/index.jsx';
import useTopicHeader from './useTopicHeader.js';
import useTopic from '../useTopic.jsx';
import ListParticipants from '../ListParticipants.jsx';
import messages from '../messages.js';
import StatusBadge from '../StatusBadge.jsx';
import { CONVERSATIONROLES } from '../constants.jsx';
import FieldButtons from '../../interaction/Form4/FieldButtons.jsx';
import useDefaultRecipientsTab from '../useDefaultRecipientsTab.js';
import useConversationsContext from '../useConversationsContext.js';

function TopicHeader(props) {
  const { markText } = props;
  const intl = useIntl();
  const { inbox, topic } = useConversationsContext();
  const [defaultRole, setDefaultRole] = useDefaultRecipientsTab();
  const { menuItems, showRcpts, onHide, handleSubmitRcpts, editTitle, handleSubmitTitle, cancelEditTitle, toggleFlagged } = useTopicHeader();
  const { ready, avatar, otherParticipants } = useTopic(topic);
  const { archived, parentTopicId, flagged } = topic;
  const [title, setTitle] = useState(topic.title);
  const flagTitle = intl.formatMessage(messages.flag);

  useEffect(() => {
    setTitle(topic.title);
  }, [topic.title]);

  if (!ready) {
    return null;
  }

  function handleSubmit(ev) {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    handleSubmitTitle(title);
  }

  function handleCancel() {
    setTitle(topic.title);
    cancelEditTitle();
  }

  const currentParticipants = otherParticipants.filter((p) => !p.archived && !p.isDeleted);

  return (
    <div className="text-dark d-flex align-items-start w-100">
      <div className="pt-1 pe-3">{avatar}</div>
      <div className="flex-grow-1">
        {editTitle ? (
          <form className="d-flex mb-3" onSubmit={handleSubmit}>
            <FormControl type="text" className="form-control" autoFocus required value={title} onChange={(e) => setTitle(e.target.value)} />
            <FieldButtons onSubmit={handleSubmit} onCancel={handleCancel} />
          </form>
        ) : (
          <h2 className="lh-base">
            <UserText inline markText={markText}>{title}</UserText>
            {archived && <StatusBadge><FormattedMessage {...messages.archived} /></StatusBadge>}
          </h2>
        )}
        <ListParticipants participants={otherParticipants} markText={markText} limit={160} allowMore />
      </div>
      <div className="d-flex flex-row align-item-start">
        <FlagButton title={flagTitle} className="pt-0 pe-2" flagged={Boolean(flagged)} onClick={toggleFlagged} />
        {!inbox.archived && !parentTopicId && !editTitle && <ControlMenu items={menuItems} className="pt-1 ps-1" hideDisabled />}
      </div>

      {showRcpts && (
        <SelectRecipients
          alwaysOpen
          required
          roles={CONVERSATIONROLES}
          value={currentParticipants}
          onCancel={onHide}
          inboxId={inbox.id}
          onChange={handleSubmitRcpts}
          defaultRole={defaultRole}
          setDefaultRole={setDefaultRole}
        />
      )}
    </div>
  );
}

TopicHeader.propTypes = {
  markText: PropTypes.string,
};

export default TopicHeader;
